/**
 * Internal Dependencies
 */
const metadata = {
  name: "email",
  supports: {
    editable: true,
    required: true,
    attachment: true,
    description: true,
    placeholder: true,
    defaultValue: true,
    logic: true,
    theme: true
  },
  attributes: {},
  logicalOperators: ["is", "is_not", "starts_with", "contains", "ends_with", "not_contains"]
};
const {
  name
} = metadata;
export { name, metadata };
//# sourceMappingURL=index.js.map